<template>
    <div class="before-login-landing">
        <LandingHeader />
        <!-- <RefferalBanner /> -->
        <!-- <MarketCardBanner /> -->
        <ShortBriefBanner />
        <div class="frame-group">
            <MarketSelect class="market-select" :style="['arvand', 'ariyosh'].includes(product) ? 'margin-top: -20px;' : ''" @@selected="() => {}" :list-options="{ public: true}" :do-list="true" :do-search="false"
                :do-filter="false" :popup-modal="true" :displayType="'none'" :no-space="true" :max-height="'unset'"
                :modalOptions="{
                    noClose: true
                }" />
            <WhyPrime />
            <HowItWorks />
            <LandingFooter />
        </div>
        <div style="height: 5px; width: 100%; background-color: #112779;">
        </div>
    </div>
</template>

<script>
import RefferalBanner from '../../components/landing/banners/RefferalBanner.vue'
import LandingHeader from '../../components/landing/LandingHeader.vue'
import MarketSelect from '../../components/selects/MarketSelect.vue';
import MarketCardBanner from '../../components/landing/banners/MarketCardBanner.vue';
import ShortBriefBanner from '../../components/landing/banners/ShortBriefBanner.vue';
import WhyPrime from '../../components/landing/WhyPrime.vue';
import HowItWorks from '../../components/landing/HowItWorks.vue';
import LandingFooter from '../../components/landing/LandingFooter.vue';
import settings from '../../settings';

export default {
    name: 'Landing',
    data() {
        return {
            product: settings.PRODUCT
        }
    },
    components: {
        RefferalBanner,
        LandingHeader,
        MarketSelect,
        MarketCardBanner,
        WhyPrime,
        HowItWorks,
        LandingFooter,
        ShortBriefBanner
    },
}
</script>

<style scoped>
:deep(._overlay_1some_5) {
    position: unset;
    background-color: unset;
}

:deep(._card_1some_26) {
    background-color: var(--color-white);
    border-radius: 24px 24px 0 0;
}

:deep(._modal_1some_1) {
    z-index: unset;
}

.market-select {
    position: relative;
    margin-top: -95px;
}

:deep(._card_1some_26 ._loading_10xx9_1) {
    min-height: 600px;
}

:deep(._modal_1some_1 ._panel_1some_17) {
    max-height: unset;
}
</style>
